/**
 * Converts Array of objects to CSV string
 * @function
 * @param [data] {Array} Array of data to be converted.
 * @returns {String} "data:text/csv;charset=UTF-8,first,second\n\"1\",\"1\"\n\"2\",\"2\"\nthird,four\n\"3\",\"3\"\n\"4\",\"4\"\n"
 * @example jsonToCsv([[{first: 1, second: 1}, {first: 2, second: 2}], [{third: 3, four: 3}, {third: 4, four: 4}]])
 */
export const jsonToCsv = (data) => {
    let result = '';
    const newLine = '\n';
    const sectionSeparator = '\uFEFF';
    const startLine = 'data:text/csv;charset=UTF-8,';

    if (!Array.isArray(data)) {
        return startLine;
    }

    result = data.filter(Boolean);

    if (!result.length) {
        return startLine;
    }

    result = result.map((section) => {
        const titles = Object.keys(section[0]).join();
        const body = section.reduce((memo, row) => memo + Object.values(row).map(val => `"${val}"`) + newLine, '');

        return titles + newLine + body;
    });

    return startLine + encodeURIComponent(sectionSeparator + result.join(sectionSeparator + newLine));
};
